import * as storage from '@aws-amplify/storage';
import { Avatar, message } from 'antd';
import React, { FunctionComponent } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Wrapper from './Avatar.styled';
import { v4 as uuidv4 } from 'uuid';

const StorageClient = new storage.StorageClass();
const MAX_SIZE = 5 * Math.pow(10, 6);

StorageClient.configure({
  AWSS3: {
    bucket: process.env.REACT_APP_AWS_BUCKET_NAME,
    region: process.env.REACT_APP_AWS_REGION,
  },
});

export interface IndigoAvatar {
  imgUrl: string;
  editable?: boolean;
  onChange?: (imgUrl: string) => void;
}

const IndigoAvatar: FunctionComponent<IndigoAvatar> = ({
  imgUrl,
  editable,
  onChange,
}) => {
  const imageRef = React.useRef<HTMLInputElement | null>(null);

  const handleChange = (selectorFiles: FileList) => {
    const file = selectorFiles[0];
    const fileExtension = file?.name?.split('.')?.pop();
    const fileSize = file?.size;

    if (file && fileExtension) {
      if (fileSize > MAX_SIZE) {
        message.error('The image size exceeds the allowable limit.');
        if (imageRef?.current) {
          imageRef.current.value = '';
        }
        return;
      }

      StorageClient.put(`${uuidv4()}.${fileExtension}`, file, {
        contentType: file.type,
      })
        .then((result: any) => {
          if (onChange) {
            onChange(result.key);
          }
        })
        .catch(err => console.log(err));
    }
  };

  return (
    <Wrapper>
      {editable ? (
        <div className="avatar-edit">
          <input
            id="avatar-edit"
            type="file"
            accept="image/gif, image/jpeg, image/png"
            onChange={(e: any) => handleChange(e.target.files)}
            ref={imageRef}
          />
          <label htmlFor="avatar-edit">
            <FontAwesomeIcon icon={['far', 'image']} />
          </label>
        </div>
      ) : null}

      <div className="avatar-preview">
        {imgUrl ? (
          <div
            style={{
              backgroundImage: `url("${imgUrl}")`,
            }}
          />
        ) : (
          <Avatar
            size={120}
            src={imgUrl}
            icon={<FontAwesomeIcon icon={['far', 'user']} />}
          />
        )}
      </div>
    </Wrapper>
  );
};

export default IndigoAvatar;
